import {useContext} from 'react'
import {Col, Form, Row, Stack} from 'react-bootstrap'
import {KTIcon} from '../../../../../_metronic/helpers'
import {PartnerContext} from '../PartnerContexts'

const GrupoAprobacionListHeader = () => {
  const {searchTerm, setCurrentPage, setSearchTerm, setOpenShowModal} = useContext(PartnerContext)

  const handleSearch = (value: string) => {
    setSearchTerm(value)
    setCurrentPage(1)
  }

  return (
    <>
      <div className='mx-8 mt-8 mb-2'>
        <Row className='mb-4'>
          <Col md={8}>
            <span className='fw-bold'>Buscar</span>
            <Stack className=' mt-3' direction='horizontal' gap={3}>
              <Form.Control
                type='text'
                className='form-control-sm'
                placeholder='Buscar...'
                value={searchTerm}
                onChange={(e) => handleSearch(e.target.value)}
              />
            </Stack>
          </Col>
          <Col xs='auto' className='mt-4 ms-auto'>
            <Stack direction='horizontal' gap={2}>
              <Stack direction='horizontal' gap={2}>
                <button
                  type='button'
                  className='btn btn-success'
                  onClick={() => setOpenShowModal(true)}
                >
                  <KTIcon iconName='plus' className='fs-2' />
                  Agregar
                </button>
              </Stack>
            </Stack>
          </Col>
        </Row>
      </div>
    </>
  )
}

export {GrupoAprobacionListHeader}
